module.exports = __webpack_public_path__ + "img/SES_TailWing_Overview.1b554b32.jpg";